import LoginComponent from './index.vue'
import ValidateComponent from './validate.vue'
import RegisterComponent from './register.vue'
import { weixin , app } from '@beastshop/browser'
import api from './api.js'

import bridge from '@beastshop/bridge'
let $vm,
  $validatevm,
  $registervm,
  login_resolve,
  login_reject,
  validate_resolve,
  validate_reject,
  register_resolve,
  register_reject

(function () {
  function install (Vue) {
    const login = function () {
      if (!$vm) {
        const Login = Vue.extend(LoginComponent)
        $vm = new Login({
          el: document.createElement('div')
        })
        document.body.appendChild($vm.$el)
      }
      $vm.$on('login-cancel', function () {
        $vm.show = false
        const error = new Error('cancel login')
        error.code = 'abort'.toUpperCase()
        error.message = 'cancel login'
        login_reject(error)
      })

      $vm.$on('login-success', function (member) {
        if (!member.mobile) {
          this.$verifiedMobile()
            .then(() => {
              $vm.show = false
              login_resolve({
                logged: true
              })
            })
            .catch(() => {
              const error = new Error('cancel Validate')
              error.code = 'abort'.toUpperCase()
              error.message = 'cancel Validate'
              login_reject(error)
            })
        }else {
          $vm.show = false
          login_resolve({
            logged: true,
            member
          })
        }
      })
      $vm.$on('to-register', function (member) {
        this.$register()
          .then(() => {
            $vm.show = false
            login_resolve({
              logged: true,
              member
            })
          })
          .catch(() => {

          })
      })
      setTimeout(() => {
        $vm.show = true
      }, 20)
      return new Promise((resolve, reject) => {
        login_resolve = resolve
        login_reject = reject
      })
    }

    const register = () => {
      if (!$registervm) {
        const Register = Vue.extend(RegisterComponent)
        $registervm = new Register({
          el: document.createElement('div')
        })
        document.body.appendChild($registervm.$el)
      }

      $registervm.$on('register-cancel', function () {
        $registervm.show = false
        const error = new Error('cancel Register')
        error.code = 'abort'.toUpperCase()
        error.message = 'cancel Register'
        register_reject(error)
      })
      $registervm.$on('register-success', function () {
        $registervm.show = false
        register_resolve({
          logged: true
        })
      })
      $registervm.$on('to-login', function () {
        $registervm.show = false
        const error = new Error('to Login')
        error.code = 'abort'.toUpperCase()
        error.message = 'to Login'
        register_reject(error)
      })
      setTimeout(() => {
        $registervm.show = true
      }, 20)
      return new Promise((resolve, reject) => {
        register_resolve = resolve
        register_reject = reject
      })
    }

    const verifiedMobile = () => {
      if (!$validatevm) {
        const Validate = Vue.extend(ValidateComponent)
        $validatevm = new Validate({
          el: document.createElement('div')
        })
        document.body.appendChild($validatevm.$el)
      }

      $validatevm.$on('validate-cancel', function () {
        $validatevm.show = false
        const error = new Error('cancel Validate')
        error.code = 'abort'.toUpperCase()
        error.message = 'cancel Validate'
        validate_reject(error)
      })
      $validatevm.$on('validate-success', function () {
        $validatevm.show = false
        validate_resolve({
          logged: true
        })
      })
      setTimeout(() => {
        $validatevm.show = true
      }, 20)

      return new Promise((resolve, reject) => {
        validate_resolve = resolve
        validate_reject = reject
      })
    }

    const ensureLogged = function ({ event = '' } = {}) {
      if (app()) {
        return bridge.ensureLogged()
      }
      return api.member()
        .then(({ data }) => {
          if (!data.mobile) {
            return this.$verifiedMobile()
              .then(() => {
                return api.member().then(({ data }) => {
                  return Promise.resolve({
                    alreadyLogged: true,
                    member: data,
                  });
                });
              })
              .catch((data) => {
                return Promise.reject(data);
              });
          }
          window.sessionStorage.setItem('_b_m', JSON.stringify(data))
          return Promise.resolve({
            alreadyLogged: true,
            member: data
          })
        })
        .catch((data) => {
          const code = data.code
          if (code == '401') {
              if (weixin()) {
                return this.$verifiedMobile()
                  .then(() => {
                    return api.member().then(({ data }) => {
                      return Promise.resolve({
                        alreadyLogged: true,
                        member: data,
                      });
                    });
                  })
                  .catch((data) => {
                    return Promise.reject(data)
                  })
              }
              
            // if (weixin()) {
            //   // window.location.reload()
            //   this.$verifiedMobile()
            //     .then(() => {
            //        api.member().then(({ data }) => {
            //          return Promise.resolve({
            //            alreadyLogged: true,
            //            member: data,
            //          });
            //        });
            //     })
            //     .catch((data) => {
            //       return Promise.reject(data)
            //     })
            // }

            if (event) {
              sa.registerButtonClick(event);
            }

            return this.$login()
          }
          if (code == '4001') {
            return this.$verifiedMobile()
                  .then(() => {
                    return api.member().then(({ data }) => {
                      return Promise.resolve({
                        alreadyLogged: true,
                        member: data,
                      });
                    });
                  })
                  .catch((data) => {
                    return Promise.reject(data)
                  })
          }
          // this.$alert("系统异常")
          // const error = new Error('sysErr')
          // error.code = 'abort'.toUpperCase()
          // error.message = 'sysErr'
            return Promise.reject(data)
        })
    }

    Vue.mixin({
      created: function () {
        this.$login = login
        this.$ensureLogged = ensureLogged
        this.$verifiedMobile = verifiedMobile
        this.$register = register
      }
    })
  }

  if (typeof exports === 'object') {
    module.exports = install
  } else if (typeof define === 'function' && define.amd) {
    define([], function () { return install })
  } else if (window.Vue) {
    Vue.use(install)
  }
})()



// WEBPACK FOOTER //
// ./static/plugins/login/index.js